import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
    },
    {
        id: 2,
        title: 'About',
        link: '/about',
    },
    {
        id: 3,
        title: 'Treatments',
        link: '/treatments',
        submenu: [
            { title: '— Pain & Orthopedics —', link: '#', isCategory: true },
            { title: 'Joint & Arthritis', link: '/service-single/joint-pain-arthritis' },
            { title: 'Chronic Pain', link: '/service-single/chronic-pain' },
            { title: 'Headache', link: '/service-single/headache' },
            { title: 'Sports Medicine', link: '/service-single/athletic-performance' },
            { title: '— Neurological & Cognitive —', link: '#', isCategory: true },
            { title: 'Neurological Recovery', link: '/service-single/neurological-recovery' },
            { title: 'Dementia Therapy', link: '/service-single/neurodegenerative-dementia' },
            { title: 'Autism Spectrum', link: '/service-single/developmental-disorders' },
            { title: '— Wellness & Performance —', link: '#', isCategory: true },
            { title: 'Sexual Wellness', link: '/service-single/sexual-wellness' },
            { title: 'Anti-Aging', link: '/service-single/anti-aging' },
            { title: "Men's Health", link: '/service-single/mens-health' },
            { title: 'MUSE Cells', link: '/service-single/muse-cells' }
        ]
    },
    {
        id: 4,
        title: 'International Patients',
        link: '/international',
    },
    {
        id: 5,
        title: 'FAQ',
        link: '/faq',
    },
    {
        id: 6,
        title: 'Blog',
        link: '/blog',
    },
    {
        id: 7,
        title: 'Contact',
        link: '/contact',
    }
]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false); // Close menu when clicking a link
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close" style={{display: menuActive ? 'block' : 'none'}}>
                    <div className="clox" onClick={() => setMenuState(false)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem key={mn}>
                                <NavLink onClick={ClickHandler} className="active"
                                    to={item.link}>{item.title}</NavLink>
                            </ListItem>
                        )
                    })}
                </ul>
                
                <div className="mobile-menu-cta">
                    <NavLink onClick={ClickHandler} to="/contact" className="cta-btn">
                        Schedule Your Consultation
                    </NavLink>
                </div>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(true)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;